import { render } from "./WorkflowSettingsCardType.vue?vue&type=template&id=4f1b3eba&scoped=true"
import script from "./WorkflowSettingsCardType.vue?vue&type=script&lang=js"
export * from "./WorkflowSettingsCardType.vue?vue&type=script&lang=js"

import "./WorkflowSettingsCardType.vue?vue&type=style&index=0&id=4f1b3eba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f1b3eba"]])

export default __exports__